import { getStyle, space6 } from "../dist/helpers"
import { MediaCarousel } from "./MediaCarousel"
import blue from "../images/arduinoProject1/blue.jpeg"
import green from "../images/arduinoProject1/green.jpeg"
import red from "../images/arduinoProject1/red.jpeg"
import zoom from "../images/arduinoProject1/zoom.jpeg"
import mb1 from "../images/car1.png"
import mb2 from "../images/car2.png"
import ibinstall from "../images/iBookInstall.MOV"
// blog 4
import amora from "../images/blog4/Amora.png"
import errMov from "../images/blog4/Error.MOV"
import gorg from "../images/blog4/Gorg.jpeg"
import ib9 from "../images/blog4/iB9.jpeg"
import iBBoot from "../images/blog4/iBBoot.jpeg"
import ibinstall2 from "../images/blog4/iBinstall.jpeg"
import iMac from "../images/blog4/iMac.jpeg"
import iMac2 from "../images/blog4/iMac2.jpeg"
import iMac3 from "../images/blog4/Imac3.jpeg"
import iMacTower from "../images/blog4/iMacTower.jpeg"
import MacProDoor from "../images/blog4/MacProDoor.jpeg"
import MacProMax from "../images/blog4/MacProMax.jpeg"
import MacPro from "../images/blog4/MacPro.jpeg"
import MacProMotherboard from "../images/blog4/MacProMotherboard.jpeg"
import mouse from "../images/blog4/mouse.jpeg"
import Somatic from "../images/blog4/Somatic.jpg"


const items = [
  {
    index: 0,
    head: "First entry: Learning how to acquire a captive audience",
    body: "There are many things in this world fighting for our attention. " +
      "Especially crap ideas like NFTs and altcoins. " +
      "While I am not usually entertained by things like that, I do however, like to watch content on crypto scams :)",
    variation: "outlined",
    date: "2022"
  },
  {
    index: 1,
    head: "Second entry: Learning how to program microcontrollers and embedded devices",
    body: "RasberryPi and ArduinoUno are some of the most popular devices you can get out there on the market today. " +
      "Which is why I fully believe these will be among my next impulse buys of 2022. What will you " +
      "create with them you might ask. Not exactly sure. But to be fair, when I created this website, " +
      "I also did not yet know its purpose. Sometimes it's better to just let things come to you. ",
    variation: "elevated",
    date: "2022"
  },
  {
    index: 2,
    head: "Third entry: First stab at Arduino, buttons, breadboards, and LEDs",
    body: "Here is my first step on the journey to creating a desktop stock ticker + graph and other related side projects like a crystal ps4 controller led conversion kit. In order to be able to tackle projects that large I figured it’d be best to start learning the fundamentals. So that’s basically what this is, just a demonstration of proficiency in wiring basics, using a breadboard, gaining back my soldering skills, and remembering how to write code for the Arduino. One thing I really like about this project is that there are many pieces that must work in order for something so seemingly simple to be pulled off.",
    body2: "All this device really does is allow for a person to press a button and have that randomly cycle the colors of the LEDs. But behind the scenes there was a lot that went into making that happen. One fun issue I ran into while making this invention was that when I purchased the LEDs, they were not soldered to breadboard legs or standoffs (not sure what called). So I first had to solder those onto the chips, and then from there get them onto the breadboard and wired up. Another issues that I’ve still yet to be able to figure out is that these particular LEDs have the ability to have the data, voltage, and ground passed through them, but that wasn’t working for me and the spec sheet doesn’t have a lot of depth. Another learning I had was figuring out how to read data into the Arduino. This was my first time creating code for the device that would change how it behaves based on input. In the images you can see I’ve used jumper wires in an attempt to clean things up as much as possible. One thing that annoys me is the resistor next to the button is poking out so much.",
    body3: "I’d really like for the ability to leave everything wired up, but that would require me purchasing an entire new Arduino which would get expensive very quickly. So I’ll probably need a way document which pins are plugged in where before I start on the next project. ",
    variation: "elevated",
    date: "2022",
    image1: blue,
    image2: green,
    image3: red,
    image4: zoom,
    image1Size: "25%",
    image2Size: "25%",
    image3Size: "25%"
  },
  {
    index: 3,
    head: "G Class",
    body: (<>
      <p>
        This recently acquired 2016 Mercedes Benz G Wagon is displayed proudly for its debut
        <br/>
        <a href="https://www.mbusa.com/en/vehicles/class/g-class/suv" target="_blank" rel="noreferrer">G-Waggon</a>
      </p>
      </>
    ),
    variation: "elevated",
    date: "2025-08-30",
    image1: mb1,
    image2: mb2,
    image1Size: "35%",
    image2Size: "35%",
  },
  {
    index: 4,
    head: "RETRO APPLE",
    body: (<>
      <p>
        Lateley, I've been spending a lot of time looking back at some retro tech. Specifically the G3 iBook, G3 iMac, and 2012 Mac Pro (5,1). 
        It's been quite fun referbishing, upgrading, and installing retro software. Takes me back to some of my early days with my first computers, playing around in the settings when in the car without wifi.
        Black PCBs look incredible.
        <br/>
        <br/>
        <a href="https://www.macintoshrepository.org" target="_blank" rel="noreferrer">Macintosh Repository</a>
        <br/>
        <br/>
        <a href="https://www.youtube.com/watch?v=Mpfhr3jrQpc" target="_blank" rel="noreferrer">ShapeShifter - Mac OS X Panther 10.3 - Amora - David Lanham</a>
      </p>
      </>
    ),
    variation: "elevated",
    date: "2026-03-14",
    video1: ibinstall,
    video2: errMov,
    image1: amora,
    image2: Somatic,
    image3: ib9,
    image4: iBBoot,
    image5: ibinstall2,
    image6: iMac,
    image7: iMac2,
    image8: iMac3,
    image9: iMacTower,
    image10: gorg,
    image11: MacPro,
    image12: MacProDoor,
    image13: MacProMax,
    image14: MacProMotherboard,
    image15: mouse,
    image1Size: "35%",
    image2Size: "35%",
  },
].reverse();

const buildMedia = (item) => {
  const media = [];
  if (item.image1) media.push({ type: 'image', src: item.image1 });
  if (item.image2) media.push({ type: 'image', src: item.image2 });
  if (item.video1) media.push({ type: 'video', src: item.video1 });
  if (item.video2) media.push({ type: 'video', src: item.video2 });
  for (let i = 3; i <= 15; i++) {
    if (item[`image${i}`]) media.push({ type: 'image', src: item[`image${i}`] });
  }
  return media;
};

const BlogCardList = (props) => {
  const { dark } = props;

  return (
    <div style={{ paddingRight: "5%", paddingLeft: "5%" }} >
      <div>
        {items.map(item => {
          const media = buildMedia(item);
          return (
            <div key={item.head}>
              <br />
              <div className="h-100 p-5"
                  style={getStyle(dark)}
                >
                  <h2 className={`${dark ? "text-white" : ""}`} > {item.head} </h2>
                  <br/>
                  <MediaCarousel media={media} dark={dark} />
              </div>


              <br />
              <br />
              <div className="col-md-6">
                <div className="h-100 p-5"
                  style={getStyle(dark)}
                >
                  <h2 className={`${dark ? "text-white" : ""}`} > {item.head} </h2>
                  <p className={`${dark ? "text-white" : ""}`} > {"Date: " + item.date} </p>


                  {/* {item.body} */}
                  {item.body ? (<h4 className={`${dark ? "text-white" : ""}`} > {item.body} </h4>) : ""}
                  {item.body2 ? (<p className={`${dark ? "text-white" : ""}`} > {item.body2} </p>) : ""}
                  {item.body3 ? (<p className={`${dark ? "text-white" : ""}`} > {item.body3} </p>) : ""}
                </div>
              </div>
              { space6 }
              { space6 }
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default BlogCardList;